(function (app, ng) {

    app.controller("addScheduledTaskController", addScheduledTaskController);

    function addScheduledTaskController($q, $state, $mdDialog, _formPattern, scheduledTaskApi, userApi, clientApi) {
        const $ctrl = this;

        const now = new Date();

        $ctrl.$onInit = () => {
            $ctrl.formPattern = _formPattern;
            $ctrl.selectedDueDate = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
            $ctrl.selectedDueTime = new Date(`${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()} ${now.getHours() + 1}:00:00`);
            $ctrl.taskIsAllDay = true;
            $ctrl.task = {
                Client: $ctrl.client,
                DueDate: `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`,
                AssignedUser: $ctrl.currentUser,
                AppointmentId: $ctrl.appointmentId
            };



            $ctrl.ui = {
                loading: false
            };
        };

        const close = () => {
            $mdDialog.cancel();
        };

        const createTask = (task, selectedDueDate, selectedDueTime) => {
            $ctrl.ui.loading = true;

            if ($ctrl.taskIsAllDay) task.DueDate = selectedDueDate;
            else task.DueDate = `${selectedDueDate} ${selectedDueTime.getHours()}:${selectedDueTime.getMinutes()}:00`;

            task.ClientId = task.Client.Id;

            task.AssignedUserId = task.AssignedUser.Id;

            scheduledTaskApi.addScheduledTask(task).then(response => {
                $state.go("Home.ScheduledTask", { taskId: response.Id }, {});

                $ctrl.close();
            });
        };

        const searchUsers = (term) => {
            return userApi.searchUsers(term).then(users => users);
        };

        const searchClients = (term) => {
            return clientApi.searchClients(term).then(clients => clients);
        };

        ng.extend($ctrl,
            {
                close,
                createTask,
                searchUsers,
                searchClients
            });

    }
})(window.app, window.angular); //jshint: ignore:line